import {
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../../Global/OrderColumn/index";
import EmptyData from "../../../Global/EmptyData";
import useCorporateOffers from "./useCorporateOffers";
import AddCorporateOffer from "./AddCorporateOffer";
import OfferDetails from "./OfferDetails";

const CorporateOffers = () => {
  const {
    isLoading,
    isFetching,
    offerList,
    offerState,
    showEditModal,
    paginationOptions,
    updateCorporateOfferFields,
    handleEditColumnsClick,
    handleDetailsClick,
    handleCreateClick,
    handlePagination,
    handleClearClick,
    handleEditAction,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = useCorporateOffers();

  return (
    <div>
      <HeadingGroup
        title={"Corporate Offers"}
        className={`pro-mb-4`}
        buttonTitle={offerList?.create_permission && "Create"}
        handleClick={handleCreateClick}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={offerState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: offerState?.search }}
          handleActionClick={handleEditColumnsClick}
        />

        {offerList?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={offerList?.result || []}
            uniqueID={"id"}
            fields={offerList?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleSort={handleSort}
            getRow={getRow}
            clear={offerState?.clearSelection}
            loading={isFetching}
            perpage={offerState?.currentPageSize}
            assignable={false}
            handleEdit={handleEditAction}
            deletable={false}
            editable={offerList?.edit_permission}
            showCheckBox={offerList?.edit_permission}
          />
        )}

        {offerList?.result?.length > 0 && (
          <Pagination
            currentPage={offerState?.currentPage}
            totalPageCount={Math.ceil(
              offerList?.total_count / offerState?.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === offerState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}

        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={offerList?.fields || []}
              moduleId={offerList?.module_id}
              updateData={updateCorporateOfferFields}
            />
          </div>
        </ModalLayout>

        <OffCanvasLayout
          show={offerState?.showCreateModal}
          handleClose={handleCreateClick}
          title={
            offerState?.isEdit ? "Update Corporate Offer" : "Add Corporate Offer"
          }
          backdrop={"static"}
        >
          <AddCorporateOffer
            handleCreateClick={handleCreateClick}
            refetch={refetch}
            isStickyFooter
          />
        </OffCanvasLayout>

        {/* lg: the activated-employees table needs more than the default dialog width. */}
        <ModalLayout
          show={offerState?.showDetailsModal}
          handleClose={handleDetailsClick}
          backdrop="static"
          size="lg"
        >
          <div className="pro-m-5">
            <OfferDetails
              offerId={offerState?.selectedId}
              handleClose={handleDetailsClick}
            />
          </div>
        </ModalLayout>
      </div>
    </div>
  );
};

export default CorporateOffers;
